import { inProcessUrls } from "./inProcessUrls";
import { deliveredUrls } from "./deliveredUrls";

export class GTR {
    static readonly IN_PROCESS = new inProcessUrls();
    static readonly DELIVERED = new deliveredUrls();
}